module.exports = __webpack_public_path__ + "img/toxic.bf8e17c0.svg";